import { TPromoType } from '../types/promos';

export const MORTGAGE_PROMO_TYPES: TPromoType[] = ['mortgage', 'bank', 'cianMortgage'];
